import { useEffect, useState } from "react";
import { onPlayersOnline } from "../lib/firebasePresence";

export default function PlayersOnline({ className = "" }) {
  const [count, setCount] = useState(null);

  useEffect(() => {
    const unsub = onPlayersOnline(setCount, 60000); // 60s window
    return () => unsub();
  }, []);

  return (
    <div className={`inline-flex items-center gap-2 rounded-full px-4 py-2 bg-white/10 border border-white/15 text-white backdrop-blur ${className}`}>
      <span className="h-2 w-2 rounded-full bg-green-400 animate-pulse" />
      <span className="font-semibold">{count ?? "—"}</span>
      <span className="opacity-80">players online</span>
    </div>
  );
}
